import { useState } from "react";
import { createGlobalStyle } from "styled-components";
import { NOTIFY } from "../based/Constants";
import TFUSelect from "../based/inputs/TFUSelect";
import CommonModal from "../based/Modal";
import { Notify } from "../based/Notify";
import FinanceServices from "../based/services/FinanceServices";

const CANCEL_REASONS = [
    { value: 1, label: "Số tài khoản khác lần cuối giao dịch" },
    { value: 2, label: "Sai số tài khoản" },
    { value: 3, label: "Sai tên tài khoản" },
    { value: 4, label: "Khách yêu cầu hủy" },
    { value: 5, label: "Lý do khác" },
];

const initForm = { reason: "", note: "" };
const MODAL_ID = "cancel-withdrawal-modal";

export default function WithdrawalCancelModal({ show, requestId, onClose, onSuccess }) {
    const [form, setForm] = useState(initForm);
    const [isBusy, setBusy] = useState(false);

    async function handleConfirm() {
        if (!form.reason) {
            Notify(NOTIFY.WARNING, "Thiếu thông tin", "Vui lòng chọn lý do hủy");
            return;
        }
        setBusy(true);
        const [err] = await FinanceServices.CancelWithdrawalRequest({
            id: requestId,
            cancelReason: form.reason,
            note: form.note,
        });
        setBusy(false);
        if (err) {
            Notify(NOTIFY.ERROR, "Lỗi", "Hủy yêu cầu thất bại. Vui lòng thử lại.");
            return;
        }
        Notify(NOTIFY.SUCCESS, "Thành công", "Đã hủy yêu cầu rút tiền");
        setForm(initForm);
        onSuccess && onSuccess();
    }

    function handleClose() {
        setForm(initForm);
        onClose();
    }

    return (
        <>
            <Wrapper />
            <CommonModal
                id={MODAL_ID}
                show={show}
                title="Hủy yêu cầu"
                size="md"
                isBusy={isBusy}
                busyMsg="Đang xử lý..."
                onClose={handleClose}
                hiddenFooter={false}
                hideOnClose={true}
                customButton={
                    <div className="d-flex">
                        <button className="btn btn-close-cancel mr-2" onClick={handleClose}>
                            Đóng
                        </button>
                        <button className="btn btn-confirm-cancel" onClick={handleConfirm} disabled={isBusy}>
                            Xác nhận hủy
                        </button>
                    </div>
                }
            >
                <div className="form-group">
                    <label>
                        Chọn lý do hủy <span className="required-mark">*</span>
                    </label>
                    <TFUSelect options={CANCEL_REASONS} value={form.reason} onChanged={(val) => setForm((f) => ({ ...f, reason: val }))} placeholder="Chọn lý do hủy" />
                </div>
                <div className="form-group">
                    <label>Ghi chú</label>
                    <textarea
                        className="form-control"
                        rows={5}
                        placeholder="Điền thêm ghi chú"
                        value={form.note}
                        onChange={(e) => setForm((f) => ({ ...f, note: e.target.value }))}
                    />
                </div>
            </CommonModal>
        </>
    );
}

const Wrapper = createGlobalStyle`
    #${MODAL_ID} .modal-header {
        background-color: #f96a74;
        border-bottom: none;
    }
    #${MODAL_ID} .modal-title {
        color: #fff;
        font-weight: 600;
        font-size: 20px;
    }
    #${MODAL_ID} button.close-btn {
        color: #fff !important;
    }
    #${MODAL_ID} .btn-close-cancel {
        background: #343c49;
        color: #fff;
        min-width: 140px;
        height: 34px;
        font-size: 14px;
        font-weight: 600;
    }
    #${MODAL_ID} .btn-confirm-cancel {
        background: #f96a74;
        color: #fff;
        min-width: 140px;
        height: 34px;
        font-size: 16px;
        font-weight: 600;
    }
    #${MODAL_ID} .required-mark {
        color: #d70000;
    }
`;
